import Icon from '@/shared/components/Icon/Icon';
import { euroFormatterNoSymbol, getEuroFormat } from '@/shared/helpers/formatters';
import { AssetBalance } from '@/types/balances';
import { IonBadge, IonLabel, IonRow, IonText } from '@ionic/react';
import styles from './AssetListItem.module.css';
import { getAssetName } from '@/shared/helpers/assets';
import { getCryptoAmount } from '@/shared/helpers/crypto';
import { useGetMarketInfoQuery } from '@/features/marketInfo/marketInfoApi';
import Tooltip from '@/shared/components/Tooltip/Tooltip';
import { t } from 'i18next';
import { useSelector } from 'react-redux';
import { RootState } from '@/app/store';
import { selectCryptoDepositsByAssetIdAndState } from '@/features/crypto/cryptoApi';

type Props = {
  assetBalance: AssetBalance;
};

const AssetListItem: React.FC<Props> = ({ assetBalance: { assetId, available, euroValue } }) => {
  const { error: marketInfoError } = useGetMarketInfoQuery(undefined);

  const isRequiringTravelRule = useSelector((state: RootState) =>
    selectCryptoDepositsByAssetIdAndState(state, assetId, 'requirestravelruleinformation')
  );
  const showNotificationForTravelRule = isRequiringTravelRule.length > 0;

  if (!assetId) return null;

  return (
    <>
      <IonRow>
        <span className={styles.assetWrapper}>
          <Icon
            size="large"
            color={assetId}
            src={`assets/icons/${assetId === 'eur' ? 'euro' : assetId}.svg`}
            className={styles.icon}
          />
          <IonLabel>
            {getAssetName(assetId)}&nbsp;
            <div className={styles.notificationBadgeContainer}>
              <small className={styles.assetBaseId}>{assetId.toUpperCase()}</small>
              {showNotificationForTravelRule && (
                <IonBadge color="warning" className={styles.notificationBadge}>
                  <IonText className={styles.badgeText}>{'Action Required'}</IonText>
                </IonBadge>
              )}
            </div>
          </IonLabel>
        </span>
      </IonRow>
      <IonRow>
        <div className={`${styles.availableWrapper}`}>
          <span>{assetId === 'eur' ? euroFormatterNoSymbol(available) : getCryptoAmount(available, assetId)}</span>
          {marketInfoError ? (
            <div>
              {t('market.info.not.available.info')}
              <Tooltip
                iconSrc="assets/icons/information-circle-outline.svg"
                id={assetId}
                showBackdrop={true}
                triggerAction="hover"
                content={t('market.info.not.available.detail.info')}
              />
            </div>
          ) : (
            <span className={styles.assetBaseId}>{assetId !== 'eur' ? getEuroFormat(euroValue) : ''}</span>
          )}
        </div>
      </IonRow>
    </>
  );
};

export default AssetListItem;
